export const resizeWrapper = () => {
  if (typeof window === 'undefined') return;
  const resizeEvent = new Event('resize');
  window.dispatchEvent(resizeEvent);
};
